import React from "react";
import { useApiData } from "../../hooks/useFetch.js";
import { api } from "../../api/api.js";
import StateGuard from "../StateGuard.jsx";
import EauChart from "../charts/EauChart.jsx";
import IrrigationJournalierChart from "../charts/IrrigationJournalierChart.jsx";
import IrrigationCumuleeChart from "../charts/IrrigationCumuleeChart.jsx";

export default function EauTab({ baseParams, culture, libelle, ecart2020 }) {
  const { data, loading, error } = useApiData(api.getEauIrrigation, baseParams, {
    skip: !baseParams.idProdu || !baseParams.gridno,
  });

  const eauXMax =
    data?.eau?.length
      ? Math.max(...data.eau.map((d) => new Date(d.date_affichage).getTime()))
      : null;
      
  return (
    <StateGuard
      loading={loading}
      error={error}
      empty={!data || (!data.eau?.length && !data.irrigation?.length)}
      emptyMessage="Pas de données eau/irrigation pour cette région / culture."
    >
      {data && (
        <>
          <div className="diagoeau-panel">
            <h3>Besoin en eau journalier</h3>
            <EauChart data={data.eau} ecart2020={ecart2020} />
          </div>
          <div className="diagoeau-panel">
            <h3>Besoin en irrigation cumulée</h3>
            <IrrigationCumuleeChart data={data.irrigation} xMax={eauXMax} ecart2020={ecart2020} />
          </div>
          <div className="diagoeau-panel">
            <h3>Besoin en irrigation journalière</h3>
            <IrrigationJournalierChart data={data.irrigation} xMax={eauXMax} ecart2020={ecart2020} />
          </div>
        </>
      )}
    </StateGuard>
  );
}